import { MenuItem, Select } from '@material-ui/core'

import { Alert } from '@mui/material'
import { MessageSetSortBy } from '../../message-set-v2/types'
import { Progress } from '@vestaboard/installables'
import React from 'react'
import { useListMessageSetTitles } from '../hooks/useListMessageSetTitles'

interface ISelectMessageSet {
  messageSet?: string | null
  setMessageSet: (messageSet: string) => void
  isNote?: boolean
}

export const SelectMessageSet = (props: ISelectMessageSet) => {
  const { data, loading, error } = useListMessageSetTitles({
    input: { limit: 1000, sortBy: MessageSetSortBy.title, public: true, isNote: props.isNote }
  })

  if (loading) {
    return <Progress />
  }

  if (error) {
    return <Alert severity='error'>There was an error loading message sets</Alert>
  }

  return (
    <Select
      variant='outlined'
      fullWidth
      value={props.messageSet}
      onChange={e => props.setMessageSet(e.target.value as string)}>
      {data?.listMessageSetsV2?.messageSets.map(messageSet => (
        <MenuItem key={messageSet.id} value={messageSet.id}>
          {messageSet.title}
        </MenuItem>
      ))}
    </Select>
  )
}
